"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.footerItems = void 0;
var footerItems = [{
  id: 'terms',
  title: 'Terms of Use',
  href: 'https://yordex.com/terms-of-use'
}, {
  id: 'privacy',
  title: 'Privacy and Cookie Policy',
  href: 'https://yordex.com/privacy'
}, {
  id: 'europevisacards',
  title: 'Europe Visa Cards End User Corporate Terms and Conditions',
  href: "https://www.yordex.com/europe-visa-cards-end-user-corporate-terms-and-conditions/"
}, {
  id: 'railsbank',
  title: 'Railsbank Terms and Conditions',
  href: 'https://www.yordex.com/railsbank-terms-and-conditions/'
}, {
  id: 'payrnet',
  title: 'Payrnet Terms and Conditions',
  href: 'https://www.yordex.com/payrnet-terms-and-conditions/'
}, {
  id: 'copyright',
  title: "Copyright \xA9 ".concat(new Date().getFullYear(), " Yordex Ltd. All rights reserved.")
}];
exports.footerItems = footerItems;